import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'footer',
    templateUrl: './footer.component.html'
})
export class FooterComponent
{
  appVersion = environment.version;
}
